<template>
  <div
    class="flex h-screen overflow-hidden relative bg-base-300 lg:space-x-2"
    :data-theme="isTheme"
  >
    <transition name="fade-slide">
      <div v-if="useUtils.isAlert" class="absolute top-20 right-5 z-[9999]">
        <AlertNotif />
      </div>
    </transition>
    <!-- sidebar -->
    <nav-sidebar />
    <div class="w-full overflow-y-auto space-y-5 relative px-2">
      <NavHeader />
      <!-- <nav-breadcrumb /> -->
      <main class="space-y-5 flex flex-col justify-between h-full">
        <RouterView />
        <nav-footer />
      </main>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useUtilsStore } from '@/stores'
import NavFooter from './NavFooter.vue'
import NavHeader from './NavHeader.vue'
import NavSidebar from './NavSidebar.vue'
import AlertNotif from './widget/AlertNotif.vue'

// Enum for theme types
enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export default defineComponent({
  name: 'MainLayout',
  components: { NavFooter, NavHeader, NavSidebar, AlertNotif },
  setup() {
    const useUtils = useUtilsStore()
    const isTheme = computed(() => useUtils.isTheme)

    onMounted(() => {
      const savedTheme = localStorage.getItem('theme') as Theme
      useUtils.toogleTheme(savedTheme || Theme.LIGHT)
    })

    return { isTheme, useUtils }
  },
})
</script>

<style>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
